import React from 'react';
import { Link } from 'react-router-dom';
import { FiMail, FiPhone, FiMapPin, FiSend, FiCheckCircle, FiClock, FiGlobe, FiUser, FiBriefcase } from 'react-icons/fi';
import './Contact.css';

const Contact = () => {
  const leadershipTeam = [
    {
      name: 'Mohammed Maafouz',
      position: 'CEO & Co-Founder',
      email: 'Ceo@crescentsadvisory.com',
      expertise: ['Strategic Advisory', 'M&A', 'Energy Sector'],
      icon: <FiUser />
    },
    {
      name: 'Aneesa Sheikh',
      position: 'CSO & Co-Founder',
      email: 'Aneesa@crescentsadvisory.com',
      expertise: ['Investment Banking', 'Commodities', 'Real Estate'],
      icon: <FiBriefcase />
    }
  ];

  return (
    <div className="contact-page">
      {/* Hero Section */}
      <section className="contact-hero">
        <div className="container">
          <h1 className="contact-hero-title">Contact Us</h1>
          <p className="contact-hero-subtitle">
            Initiate a confidential discussion with our senior advisors. All inquiries are 
            handled with strict confidentiality and reviewed by our team promptly.
          </p>
        </div>
      </section>

      {/* Leadership Team Section */}
      <section className="leadership-section">
        <div className="container">
          <h2 className="section-title center">Our Leadership Team</h2>
          <p className="section-subtitle center">
            Direct access to senior advisors for confidential discussions
          </p>
          <div className="leadership-grid">
            {leadershipTeam.map((leader, index) => (
              <div key={index} className="leadership-card">
                <div className="leader-icon">
                  {leader.icon}
                </div>
                <h3 className="leader-name">{leader.name}</h3>
                <p className="leader-position">{leader.position}</p>
                <a href={`mailto:${leader.email}`} className="leader-email">
                  <FiMail /> {leader.email}
                </a>
                <div className="leader-expertise">
                  {leader.expertise.map((exp, i) => (
                    <span key={i} className="expertise-tag">{exp}</span>
                  ))}
                </div>
                <a 
                  href={`mailto:${leader.email}?subject=Confidential%20Inquiry&body=Dear%20${leader.name}%2C%0A%0AI%20would%20like%20to%20discuss%20a%20confidential%20matter%20with%20you.%0A%0ABest%20regards%2C%0A[Your%20Name]`} 
                  className="btn-schedule"
                >
                  Schedule Confidential Call
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>

     
      {/* Sidebar/Info Section */}
      <section className="info-section">
        <div className="container">
          <div className="info-grid">
            <div className="info-card">
              <h3>Confidentiality First</h3>
              <p>
                All inquiries are protected by our strict confidentiality protocols. We will 
                respond under executed NDA when appropriate.
              </p>
              <div className="info-features">
                <div className="info-feature">
                  <FiCheckCircle />
                  <span>End-to-end encryption</span>
                </div>
                <div className="info-feature">
                  <FiCheckCircle />
                  <span>Strict data protection</span>
                </div>
                <div className="info-feature">
                  <FiCheckCircle />
                  <span>Senior advisor review</span>
                </div>
              </div>
              <Link to="/investor-portal" className="btn-outline">
                Access Investor Portal
                <FiGlobe />
              </Link>
            </div>

            <div className="info-card">
              <h3>Response Commitment</h3>
              <p>We aim to respond to all qualified inquiries within:</p>
              <div className="response-time">
                <span className="time-number">24-48</span>
                <span className="time-unit">hours</span>
              </div>
              <div className="direct-contacts">
                <div className="direct-contact">
                  <FiUser className="contact-icon-small" />
                  <div>
                    <strong>Mohammed Maafouz</strong>
                    <a href="mailto:Ceo@crescentsadvisory.com">Ceo@crescentsadvisory.com</a>
                  </div>
                </div>
                <div className="direct-contact">
                  <FiBriefcase className="contact-icon-small" />
                  <div>
                    <strong>Aneesa Sheikh</strong>
                    <a href="mailto:Aneesa@crescentsadvisory.com">Aneesa@crescentsadvisory.com</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;